
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./ibcsearch/ibcsearch'));
    processInclude(require('./ibcsearch/ibcFilter'));
});
require('./components/customSpinner');
